// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip[data-v-23aa170c] {\n  position: absolute;\n  visibility: hidden;\n  color: white;\n  background-color: #0d47a1;\n  padding: 2px;\n  border-radius: 4px;\n  z-index: 99999;\n  width: 70px;\n  overflow-wrap: break-word;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
